import { render } from "./VideoOverView.vue?vue&type=template&id=58717f17"
import script from "./VideoOverView.vue?vue&type=script&lang=js"
export * from "./VideoOverView.vue?vue&type=script&lang=js"

import "./VideoOverView.vue?vue&type=style&index=0&id=58717f17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__